<template>
  <div>
    <v-card v-for="item in TransData" :key="item.key" flat class="mt-3 mb-3">
      <table>
        <tbody>
          <tr>
            <td>Transaction Id</td>
            <td>
              <b>{{ item.transaction_id }}</b>
            </td>
            <td>Partner Txd ID</td>
            <td>
              <b>{{ item.partner_txn_id }}</b>
            </td>
            <td>Transcation Date</td>
            <td>
              <b>{{ item.send_date }}</b>
            </td>
          </tr>

          <tr>
            <td>Transfer Amount</td>
            <td>
              <b>{{ item.sending_amount }}</b>
            </td>
            <td>Collected Amount</td>
            <td>
              <b>{{ item.amount_sent }}</b>
            </td>
            <td>Service fee</td>
            <td>
              <b>{{ item.transfer_fee }}</b>
            </td>
          </tr>

          <tr>
            <td>Exchange Rate</td>
            <td>
              <b>{{ item.coll_ex_rate }}</b>
            </td>
            <td>Status</td>
            <td>
              <b>{{ item.status }}</b>
            </td>
            <td>Payment Mode</td>
            <td>
              <b>{{ item.mode_of_payment }}</b>
            </td>
          </tr>

          <tr>
            <td>Account Number</td>
            <td>
              <b>{{ item.account_number }}</b>
            </td>
            <td>Beneficiary Name</td>
            <td>
              <b>{{ item.beneficiary_name }}</b>
            </td>
            <td>Country</td>
            <td>
              <b>{{ item.country }}</b>
            </td>
          </tr>
          <tr>
            <td>Suspicious</td>
            <td>
              <b v-if="item.is_suspected">Yes</b>
              <b v-else>No</b>
            </td>
            <td>Suspicious Reason</td>
            <td>
              <b>{{ item.suspicious_reason }}</b>
            </td>
            <td>Bank Name</td>
            <td>
              <b>{{ item.bank_name }}</b>
            </td>
          </tr>
          <tr>
            <td>Swift Code</td>
            <td>
              <b>{{ item.swift_code }}</b>
            </td>
            <td>Relationship</td>
            <td>
              <b>{{ item.relation_with_remitter }}</b>
            </td>
            <td>Upload Files</td>
            <td>
              <b>{{ item.upload_files }}</b>
            </td>
          </tr>
          <tr>
            <td>Remarks</td>
            <td>
              <b>{{ item.remarks }}</b>
            </td>
            <td>Risk Status</td>
            <td>
              <b>{{ item.risk_status }}</b>
            </td>
            <td>Risk Percentage</td>
            <td>
              <b>{{ item.risk_percentage }}</b>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- {{ item.account_number }} -->
    </v-card>
  </div>
</template>

<script>
export default {
  name: "BreadCrumb",
  data: () => {
    return {};
  },

  props: {
    TransData: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  font-family: "Open Sans", sans-serif;
  border: none;
  width: 100%;

  tbody {
    td {
      text-align: left;
      padding: 5px;
      vertical-align: middle;
      font-size: 14px;
      font-weight: normal;
      border: none;
      margin: 5px;
    }
  }
}
</style>
